import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { UserAvatarComponent } from "../../../../shared/components/user-avatar/user-avatar.component";
import { APP_NAME } from "../../../../core/constants/app.constants";

@Component({
  selector: "app-mobile-top-bar",
  standalone: true,
  imports: [UserAvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./mobile-top-bar.component.html",
  styleUrl: "./mobile-top-bar.component.scss",
})
export class MobileTopBarComponent {
  readonly appName = APP_NAME;
  readonly displayName = input<string>("");
  readonly avatarUrl = input<string | null>(null);
  readonly darkMode = input<boolean>(false);

  readonly openProfile = output<void>();
  readonly toggleDarkMode = output<void>();
}
